import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"

const Initiative = () => {
    useEffect(() =>{
        document.title = "Initiative | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="hmfirstbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Life Initiative</h3>
        <p className='description hmfirstboxdescription'>
        Rich-Oak life initiative was incorporated in 2018 as a Non-Governmental Organization in a bid to deepen financial inclusion and step down financial services to the under-served, by providing relevant trainings and financial empowerment to women in rural areas, to enable them set up and scale up their businesses, support themselves and their families better
        </p>
        
        {/* <p class="centermobile">
        <button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button>
        <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4>
        </p> */}

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox'>
    
    </div>


    <div className='hmthirdbox'>
    <div className=''>
        {/* <Container> */}
            <Row>
                <div className='col-md-6 hideipad'>
                <img style={{width:"100%"}} src="images/whoweare.png"/> 
                {/* <iframe className="img-fluid" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
                    </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-lg-6 col-md-12'>
                    <h1 className="hmwwd">Our <span style={{color:"#D80032"}}> Impact </span></h1>
                    {/* <hr class="hpwwdhr1"/> */}
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, 
                        innovation and providing premium value. Our vision is to be Africa's most reliable financial partner. 
                        We invest capital on behalf of individuals and institutions across the alternative asset classes in real estate, 
                        credit and agriculture, increasing the wealth of our investors.
                         Our businesses are impact driven, providing support to various industries and sectors.</p>
                    </div>

                    {/* <div className='col-md-5 formobileonly'>
                <iframe className="img-fluid hmytvideo" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> */}

               
                
            </Row>
        {/* </Container> */}
        </div>

        
    </div>


 

 <div className='hmfourthbox'>
 <Row>
                      

                      <div class="col-lg-6 col-md-12 blogmobile">
                          <img class="blogimagemobile" style={{width:"100%"}} src="images/blog1.png"/>
                          <p className='hmciahead' style={{marginTop:"30px",marginLeft:"10px"}}>Reach <span style={{color:"#D80032"}}>HER</span> Project</p>
                          <p className='hmblogbody'>
                              
                          The real estate investment fund allows Interested Investors hold a portion of prime real estate assets without needing to come up with the entire purchase amount while enjoying good returns.
                               </p>
                               <a target="_blank" href="https://earthvii.com/homes">
                               <button  style={{marginLeft:"10px"}} class="hmfirstboxbutton">LEARN MORE</button>
                                   </a>

                               {/* <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p> */}

                      </div>

                      <div class="col-lg-6 col-md-12 blogmobile">
                      <img class="blogimagemobile2" style={{width:"100%"}}  src="images/blog2.png"/>
                      <p className='hmciahead' style={{marginTop:"30px",marginLeft:"10px"}}>Every <span style={{color:"#D80032"}}>woman</span> has a story</p>
                      <p className='hmblogbody'>
                      We provide affordable premium and luxury residential real estate with payment plans to reduce the burden of making a full deposit. We are not just building structures, we are building lasting homes to hold memories for generations.
                               </p>

                               <a target="_blank" href="https://earthvii.com/homes">
                               <button  style={{marginLeft:"10px"}} class="hmfirstboxbutton">LEARN MORE</button>
                                   </a>
                               {/* <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p> */}

                      </div>

                 
                  </Row>
 <div className='col-md-12'>
           <br/>
           <br/>
           <br/>
           <br/>
            </div>
    <div className=''>

            <Row>
         

                    <div className='col-md-5 divinvestments4 blogmobile'>
                    <div className=' blogmobile'>
                        <p className="hmciahead" style={{marginTop:"30px"}}> Mission</p>
                        <p  className='hmfourthboxinner'>
                        We identify real estate opportunities in prime locations across Abuja Nigeria. We look out for developed and secure locations with access to the city center and basic daily essentials.                          
                            </p>
                            </div>
                    </div>

                    <div className='col-md-1'></div>

                    <div className='col-md-5 divinvestments4'>
                    <div className=' blogmobile'>
                        <p className="hmciahead" style={{marginTop:"30px"}}>Vision</p>
                        <p  className='hmfourthboxinner'>Our team of professionals provide expertise input through a rigorous evaluation process carrying out all necessary due diligence to vet all identified properties in-other to ensure a smooth and secure transaction.</p>
                        </div>
                   </div>

    
               
               
                
            </Row>

        
   
        </div>
    </div> 



    <div className='hmseventhbox'>
    <div className=''>
    <h1 className="hmwwd2 fordesktoponly">Creating a great <span style={{color:"#D80032"}}>experience for you<br/></span> begins with  a conversation.</h1>
    <h1 className="hmwwd2 formobileonly">Creating a great <span style={{color:"#D80032"}}>experience for you </span> begins with a conversation.</h1>

            <hr class="hpwwdhr3"/>
       
            <Row className="innerboxseven">
        

                <div className='col-md-5'>
                    <h1 className='hmwwd2head'>Contact Info</h1>
                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                    </p>

<div className='innersesventhbody'>
                    <Row>
                        <div class="col-lg-1 col-md-2">
                            <img src="images/icons/phone.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <h1 className='innerboxsevendescriptionicon'>Phone number</h1>
                            <p className='innerboxsevendescriptiontext'>+234 123 456 7890, +234 123 456 7890</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/mail.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Email address</p>
                            <p className='innerboxsevendescriptiontext'>samplemail@rich-oaks.com<br/> anothersamplemail2@rich-oaks.com</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/office.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Address</p>
                            <p className='innerboxsevendescriptiontext'>Plot 1072 Grand Pela Hotel Street, Durumi Area 1. Abuja</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-lg-1 col-md-2">
                            <img src="images/icons/clock.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Office Hours</p>
                            <p className='innerboxsevendescriptiontext'>Mondays - Fridays: 9am - 5pm</p>
                        </div>
                    </Row>
                    </div>

                </div>
<hr className="hrmobile formobileonly"/>
                    <div className='col-md-1'></div>

                    <div className='col-md-5'>
                    <h1 className='hmwwd2head hmwwd2headmobile'>You can reach out to us</h1>

                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                                          </p>

                                          <form className='hmformmobile'>
  <div class="form-group">
    <label className='hmlabel' for="">Full Name</label>
    <input type="email" class="form-control form-control-lg hminput" id=""placeholder="Enter email"/>
  </div>


  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Email Address</label>
    <input type="password" class="form-control form-control-lg hminput" id="" placeholder="Password"/>
  </div>

  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Message</label>
    <textarea class="form-control hminput" id="" rows="6"></textarea>
  </div>

  <button type="submit" class="hmfirstboxbutton">SEND YOUR MESSAGE</button>
</form>
                  
                    </div>

            
                  
                 
            </Row>
        </div>
    </div>




<br/>
<br/>


    </div>







    <Footer/>
    </div>


    )
    
    
}


export {Initiative as default}